import { fetchAPI } from "lib/api"
import { Q_SANDBOX } from "lib/query"

export default function Sandbox({ data }) {
  console.log("data", data)
  return <h1>asoufdhaosf</h1>
}

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await fetchAPI(Q_SANDBOX, {})
  return {
    props: {
      data,
      locale,
    },
    revalidate: 60,
  }
}
